import type { ProviderFile } from "fileParsing/types";
import { isSimilarData, mergeUnionTypes } from "./wrangler/schema";
import { EMPTY_SCHEMA, UserInteractionStatus, type WranglerItem } from "./wrangler/types";

export const groupFiles = (files: ProviderFile[], exportId: number) => {
  const items: WranglerItem[] = [];

  // Iterate over all schemas
  while (files.length > 0) {
    const [head, ...rest] = files;
    const schema = head.parserData.schema ?? EMPTY_SCHEMA;
    const fileGroup = [head, ...rest.filter((f) => isSimilarData(schema, f.parserData.schema ?? EMPTY_SCHEMA))];
    files = rest.filter((f) => !fileGroup.some(({ id }) => id === f.id));
    items.push({
      id: items.length,
      name: commonName(fileGroup.map(({ path }) => path)),
      exportId,
      schema: fileGroup
        .slice(1)
        .reduce(
          (schema, file) => mergeUnionTypes(schema, file.parserData.schema ?? EMPTY_SCHEMA),
          fileGroup[0].parserData.schema ?? EMPTY_SCHEMA,
        ),
      templates: [],
      category: undefined,
      userStatus: UserInteractionStatus.Automatic,
      dataProgress: {
        isNotEmpty: fileGroup.some((file) => (file.parserData.byteData?.length ?? 0) > 0),
        foundDataPoints: false,
        hasTimestamp: false,
        guessedCategory: false,
        didCompile: false,
      },
      files: fileGroup,
    });
  }
  return items;
};

export const commonName = (filePaths: string[]) => {
  if (filePaths.length === 0) return "";
  const tokens = filePaths.reduce<string[]>(
    (result, path) =>
      path
        .split("/")
        .reduce<string[]>((result, _, ix, arr) => {
          return result.concat(arr.slice(0, ix + 1).join("/"));
        }, [])
        .concat(result),
    [],
  );

  const histogram = tokens.reduce<{ [token: string]: number }>((hist, token) => {
    if (hist[token] !== undefined) {
      return Object.assign(hist, { [token]: hist[token] + 1 });
    }
    return { ...hist, [token]: 1 };
  }, {});

  return Object.entries(histogram).sort((a, b) => {
    const dCount = b[1] - a[1];
    if (dCount === 0) return b[0].length - a[0].length;
    return dCount;
  })[0][0];
};
